import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { createAddress } from '../../../services/addressService';

const AddAddress: React.FC = () => {
  const { id } = useParams<{ id: string }>(); // Get related_to_id from URL
  const [formData, setFormData] = useState({
    related_to_id: id,
    related_to_type: 'Institute', // Automatically set to "Institute"
    address_type: '',
    street: '',
    city: '',
    state: '',
    zip: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccessMessage(null);

    try {
      const response = await createAddress(formData);
      setSuccessMessage(response.message || 'Address added successfully!');
      setFormData({
        related_to_id: id,
        related_to_type: 'Institute',
        address_type: '',
        street: '',
        city: '',
        state: '',
        zip: ''
      });
    } catch (err) {
      setError('Failed to create address. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <Card className="shadow p-4">
        <Card.Body>
          <Card.Title className="fw-bold">Add Address</Card.Title>

          {successMessage && <Alert variant="success">{successMessage}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Address Type</Form.Label>
              <Form.Select
                name="address_type"
                value={formData.address_type}
                onChange={handleChange}
                required
              >
                <option value="">Select Type</option>
                <option value="Billing">Billing</option>
                <option value="Shipping">Shipping</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Street</Form.Label>
              <Form.Control
                type="text"
                name="street"
                value={formData.street}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <Form.Control
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <Form.Control
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>ZIP Code</Form.Label>
              <Form.Control
                type="text"
                name="zip"
                value={formData.zip}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? (
                <Spinner as="span" animation="border" size="sm" role="status" />
              ) : (
                'Add Address'
              )}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AddAddress;
